<template lang="pug">
.qmodii-modal-content
  VCard
    VCardTitle
      span.headline {{ $t('screener.savedscreens') }}
    VCardText
      VTabs(v-model="savedtabs")
        VTab {{ $t('screener.saved') }}
        VTab {{ $t('screener.new') }}
      VTabsItems(v-model="savedtabs")
        VTabItem
          VLayout(align-space-around, justify-center, column, v-if="options.length")
            VFlex(xs12)
              VList(three-line, dense)
                VListTile(
                  v-for="item in options",
                  :key="item.id",
                  @click="setScreen(item)"
                )
                  VListTileContent
                    VListTileTitle {{ item.name }}
                    VListTileSubTitle {{ item.description }}
                  VListTileAction
                    VBtn(color="red", small, @click.stop="removeScreen(item)")
                      | {{ $t('labels.remove') }}
          VLayout(align-space-around, justify-center, column, v-else)
            VFlex(xs12)
              span {{ $t('screener.nosaved') }}.
        VTabItem
          VLayout(align-space-around, justify-center, column)
            VFlex(xs12)
              VTextField(
                :label="$t('screener.entername')",
                v-model="savescreenername",
                :error-messages="errormsg"
              )
            VFlex(xs12)
              Span {{$t('screener.or')}}
            VFlex(xs12)
              VSelect(
                :no-data-text="$t('screener.nodata')"
                :label="$t('screener.updateexisting')"
                v-model="existing"
                :items="options"
                item-value="id"
                item-text="name"
                )
    VCardActions
      VBtn(color="blue darken-1", flat, @click.native="close") {{ $t('labels.close') }}
      VSpacer
      VBtn(
        v-if="savedtabs == 1",
        color="primary",
        :loading="savingscreens",
        :disabled="savingscreens",
        small,
        @click="saveCurrentScreen()"
      ) {{$t('screener.save')}}
</template>

<script>
import {
  VDialog,
  VTab,
  VTabs,
  VTabsItems,
  VTabItem,
  VExpansionPanel,
  VExpansionPanelContent,
  VList,
  VSubheader,
  VListTile,
  VListTileContent,
  VListTileTitle,
  VListTileSubTitle,
  VListTileAction,
  VLayout,
  VFlex,
  VTextField,
  VSelect,
  VIcon,
  VBtn,
  VSpacer,
  VCard,
  VCardTitle,
  VCardText,
  VCardActions,
} from "vuetify/lib";
import ToggleButton from "@LAYOUT/ToggleButton";
import axios from "axios";

export default {
  name: "indicatorModal",
  components: {
    VDialog,
    VTabsItems,
    VTabItem,
    VTab,
    VTabs,
    VExpansionPanel,
    VExpansionPanelContent,
    VList,
    VSubheader,
    VListTile,
    VListTileContent,
    VListTileTitle,
    VListTileSubTitle,
    VListTileAction,
    VLayout,
    VFlex,
    VTextField,
    VSelect,
    VIcon,
    ToggleButton,
    VBtn,
    VSpacer,
    VCard,
    VCardTitle,
    VCardText,
    VCardActions,
  },
  props: ["enabled", "list", "activeTab"],
  data() {
    return {
      savescreenername: null,
      modal2: true,
      options: [],
      savedtabs: 0,
      existing: null,
      savingscreens: false,
      errormsg: [],
    };
  },
  methods: {
    close() {
      this.$emit("finished");
    },
      async saveCurrentScreen() {
        if (!this.savescreenername && !this.existing) {
            return;
        }
        this.savingscreens = true;
        
        let screentosave = {
          fixedFilters: [],
          rangedFilters: []
        }
        this.$store.state.MarketScreener.ACTIVE_CRITERIA.forEach((screen) => {
          if (screen.list) { // Fixed
            screentosave['fixedFilters'].push(
              {
                alias: screen.id,
                min: screen.minRange,
                max: screen.maxRange,
                selected: screen.selected,
                list: screen.list,
              }
            );
            }
          else {
            screentosave['rangedFilters'].push(
              {
                alias: screen.id,
                min: screen.minRange,
                max: screen.maxRange,
                selected: screen.selected,
                list: screen.list,
              });
            };
        });

        var result;

        if (this.existing) {
            try {
                await axios.put(
                    `//${
                        this.$store.state.ENV
                    }.quotemedia.com/screener/screens/saved/datatool/type/${
                        this.$store.state.MarketScreener.CURRENT_SCREENER
                    }?webmasterId=${
                        this.$store.state.WMID
                    }&id=${this.existing}&token=${this.$store.state.MarketScreener.componentToken}${
                        this.$store.state.SID ? "&sid=" + this.$store.state.SID : ""
                    }`,
                    {
                        settings: JSON.stringify(screentosave),
                    },
                    {withCredentials: true}
                );
            }
            catch (e) {
                console.error(e);
            }
        }
        else {
            try {
                result = await axios.post(
                    `//${
                        this.$store.state.ENV
                    }.quotemedia.com/screener/screens/saved/datatool/type/${
                        this.$store.state.MarketScreener.CURRENT_SCREENER
                    }?wmid=${
                        this.$store.state.WMID
                    }&token=${this.$store.state.MarketScreener.componentToken}${
                        this.$store.state.SID ? "&sid=" + this.$store.state.SID : ""
                    }`,
                    {
                        name: this.savescreenername,
                        settings: JSON.stringify(screentosave),
                    },
                    {withCredentials: true}
                );
            }
            catch (errr) {
                this.errormsg = errr.response.data.error;
                this.savingscreens = false;
                return;
            }
        }
          this.savingscreens = false;
        this.$emit("finished");
    },
    async removeScreen(screen) {
      let sID = screen.id;
      try {
        await this.$qModCore.axios.delete(
          `//${
            this.$store.state.ENV
          }.quotemedia.com/screener/screens/saved/datatool/type/${
            this.$store.state.MarketScreener.CURRENT_SCREENER
          }/id/${sID}?webmasterId=${
            this.$store.state.WMID
          }&token=${this.$store.state.MarketScreener.componentToken}${
            this.$store.state.SID ? "&sid=" + this.$store.state.SID : ""
          }`,
          { withCredentials: true }
        );

        await this.getScreens();
        // this.options = criteriaResults.data.savedScreenerResponseDTO;
      } catch (e) {
        return "INVALID";
      }
    },
    closeModal() {
      this.$store.commit("AdvancedChart/SET_MODAL_ISOPEN", false);
    },
    async getScreens() {
      try {
        const criteriaResults = await this.$qModCore.axios.get(
          `//${
            this.$store.state.ENV
          }.quotemedia.com/screener/screens/saved/datatool/type/${
            this.$store.state.MarketScreener.CURRENT_SCREENER
          }?webmasterId=${
            this.$store.state.WMID
          }&token=${this.$store.state.MarketScreener.componentToken}${
            this.$store.state.SID ? "&sid=" + this.$store.state.SID : ""
          }`,
          { withCredentials: true }
        );

        this.options = criteriaResults.data.savedScreenerResponseDTO;
      } catch (e) {
        return "INVALID";
      }
    },
    //
    async setScreen(screen) {

      let screens = JSON.parse(screen.settings);
      let fakeobj;
      
      // Handle new format - check if it's an array of objects with id, selected, min, max
      if (Array.isArray(screens)) {
        // Convert new format to old format
        let rangedFilters = [];
        let fixedFilters = [];
        
        screens.forEach(filter => {
          let convertedFilter = {
            alias: filter.id,
            selected: filter.selected || [],
            min: filter.min,
            max: filter.max
          };
          
          // Special handling for exchangeGroups - convert exchange IDs to keys
          if (filter.id === 'exchangeGroups' && filter.selected && Array.isArray(filter.selected)) {
            const availableExchanges = this.$store.state.MarketScreener.AVAILABLE_EXCHANGES;
            
            // Only convert if exchanges are loaded
            if (availableExchanges && Object.keys(availableExchanges).length > 0) {
              convertedFilter.selected = filter.selected.map(selectedVal => {
                // Check if selectedVal is an exchange ID (like "AMX", "NSD", "NYE")
                const exchangeEntry = Object.entries(availableExchanges).find(([, exchangeVal]) => {
                  return exchangeVal.id === selectedVal;
                });
                
                if (exchangeEntry) {
                  // Return the key (what the dropdown expects)
                  return exchangeEntry[0];
                }
                
                // If not found or already a key, return as-is
                return selectedVal;
              });
            }
          }
          
          // If it has min/max values, it's a ranged filter, otherwise it's a fixed filter
          if (filter.hasOwnProperty('min') && filter.hasOwnProperty('max') && 
              (filter.min !== undefined || filter.max !== undefined)) {
            rangedFilters.push(convertedFilter);
          } else {
            fixedFilters.push(convertedFilter);
          }
        });
        
        fakeobj = {
          rangedFilters: rangedFilters,
          fixedFilters: fixedFilters
        };
      }
      // Handle old format
      else if (screens.rangedFilters) {
        fakeobj = screens;
        // Apply exchange ID conversion to old format as well
        this.convertExchangeIdsInFilters(fakeobj);
      }
      else {
        fakeobj = {
          rangedFilters: screens,
        };
        // Apply exchange ID conversion to old format as well
        this.convertExchangeIdsInFilters(fakeobj);
      }

      await this.$store.dispatch(
        "MarketScreener/setEquityFromScreens",
        fakeobj
      );
      this.close();
    },
    convertExchangeIdsInFilters(fakeobj) {
      // Helper method to convert exchange IDs to keys in both ranged and fixed filters
      const availableExchanges = this.$store.state.MarketScreener.AVAILABLE_EXCHANGES;
      
      // If exchanges aren't loaded yet, skip conversion (the state.js mutations will handle it)
      if (!availableExchanges || Object.keys(availableExchanges).length === 0) {
        return;
      }
      
      const convertExchangeIds = (filters) => {
        if (!filters) return;
        
        filters.forEach(filter => {
          if (filter.alias === 'exchangeGroups' && filter.selected && Array.isArray(filter.selected)) {
            filter.selected = filter.selected.map(selectedVal => {
              // Check if selectedVal is an exchange ID (like "AMX", "NSD", "NYE")
              const exchangeEntry = Object.entries(availableExchanges).find(([, exchangeVal]) => 
                exchangeVal.id === selectedVal
              );
              
              if (exchangeEntry) {
                // Return the key (what the dropdown expects)
                return exchangeEntry[0];
              }
              
              // If not found or already a key, return as-is
              return selectedVal;
            });
          }
        });
      };
      
      // Apply conversion to both filter types
      convertExchangeIds(fakeobj.rangedFilters);
      convertExchangeIds(fakeobj.fixedFilters);
    },
  },
  computed: {
    getEnabled() {
      return this.isEnabled ? "On" : "Off";
    },
  },
    mounted() {
      this.savedtabs = this.activeTab;
    },
    async created() {
    await this.getScreens();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus">
.qmodii-modal-content
  width 100%
.qmod-color-box-cont
  display flex
  justify-content space-between
  margin-top 5px
  .qmod-color-box
    max-width 30px
    height 30px
    flex auto
    cursor pointer
    text-align center
    color #fff
    &.qmod-color-box-active
      border 1px solid black
      &:after
        position relative
        top 3px
        content '✔'
.qmodii-select.qmodii-input-color, .qmodii-input.qmodii-input-color
  width 100%
  max-width 100%
  height 30px
.qmodii-active-list-item
  &.qmodii-modal-btn-bar
    margin-top 10px
.qmodii-list-item, .qmodii-active-list-item
  border-bottom 1px solid #e4e4e4
  margin 2px 0
  display flex
  align-items center
  .qmodii-c-mag
    margin-left 2px
    .qmodii-btn
      border-radius 50%
      padding 8px
      transition background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms
      &.qmodii-active, &:hover
        border 2px solid black
  .qmodii-marg-left
    margin-left auto
  .qmodii-marg-right
    flex 1
    margin-right auto
  .qmodii-marg-auto
    margin auto
</style>
